import {hasLogin, getUser} from '@/services/auth'

function getRoleDisplay (role) {
  return this.roleList[role] || role
}

export default {
  data () {
    return {
      roleList: {
        admin: '超级管理员',
        print_worker: '打印厂普通账户',
        print_finance: '打印厂财务',
        company: '第三方公司'
      }
    }
  },
  methods: {
    hasLogin,
    getRoleDisplay
  },
  computed: {
    user () {
      return getUser() || {}
    },
    isAdmin () {
      return this.user.role === 'admin'
    },
    isPrinter () {
      return this.user.role === 'print_worker' || this.user.role === 'print_finance'
    },
    isFinance () {
      return this.user.role === 'print_finance'
    },
    isCompany () {
      return this.user.role === 'company' || this.user.role === 'company_readonly'
    },
    isCompanyReadonly () {
      return this.user.role === 'company_readonly'
    }
  }
}
